// extracted by mini-css-extract-plugin
module.exports = {"activateAccount":"styles_activateAccount__1UdZp","form":"styles_form__1YXy4"};